import {StyleSheet} from 'react-native';
import {ITheme} from 'contexts/ThemeContext';

export default ({colors, typography}: ITheme) => {
  return StyleSheet.create({
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      marginTop: 12,
      marginBottom: 12,
      marginLeft: 20,
      marginRight: 20,
    },
    userImageContainer: {
      width: 30,
      height: 30,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 15,
      backgroundColor: colors.purple(0.13),
    },
    disabledImage: {
      width: 20,
      height: 20,
    },
    disabledContainer: {
      width: 30,
      height: 30,
      borderRadius: 15,
      backgroundColor: colors.purple(0.13),
      justifyContent: 'center',
      alignItems: 'center',
    },
    userImageText: {
      fontSize: 10,
      ...typography.interMedium,
      color: colors.purple(1),
    },
    name: {
      flex: 1,
      fontSize: 16,
      ...typography.interRegular,
      marginLeft: 12,
    },
    spacer: {
      width: 12,
    },
  });
};
